import $ from 'jquery';

import { Contact } from '../../models/contact';

import DefaultPageCollection from 'base/collections/page';

const AllContactsCollection = DefaultPageCollection.extend({
  model: Contact,

  constructor(models, options) {
    this.options = options;
    this.urlBase = `/names-filter/${options.filter}/names/`;
    DefaultPageCollection.apply(this, arguments);
  },

  urlBase: '/names-filter/names/',

  queryParams: {
    totalRecords: null,
    totalPages: null,
    offset() {
      return (this.state.currentPage - 1) * this.state.pageSize;
    },
    limit() {
      return this.state.pageSize;
    }
  },

  addToSelection() {
    const baseUrl = this.url();
    const { filter, contact_type } = this.search_params;
    const query = $.param({ filter, contact_type });
    const url = `${baseUrl}?format=json&${query}`;

    return $.post(url, { selected: 'true' });
  }
});

module.exports = AllContactsCollection;



// WEBPACK FOOTER //
// ./base/collections/contacts/all.js